var _ellipse, _rect, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTable4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 420,
    viewBox: "0 0 420 420",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 210,
    cy: 210,
    rx: 170,
    ry: 170,
    fill: "#000",
    opacity: 0.08
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 60,
    width: 300,
    height: 300,
    rx: 30,
    fill: "#8B5A2B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 130,
    r: 42,
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 130,
    r: 30,
    fill: "none",
    stroke: "#ddd",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 290,
    r: 42,
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 290,
    r: 30,
    fill: "none",
    stroke: "#ddd",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 210,
    r: 42,
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 210,
    r: 30,
    fill: "none",
    stroke: "#ddd",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 210,
    r: 42,
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 210,
    r: 30,
    fill: "none",
    stroke: "#ddd",
    strokeWidth: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#aee1f9",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 80,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 340,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 210,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 210,
    r: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#bbb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 40,
    width: 4,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 40,
    width: 4,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 340,
    width: 4,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 340,
    width: 4,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 195,
    width: 40,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 220,
    width: 40,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 195,
    width: 40,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 220,
    width: 40,
    height: 4
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#444"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 10,
    width: 120,
    height: 25,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 35,
    width: 80,
    height: 20,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 385,
    width: 120,
    height: 25,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 365,
    width: 80,
    height: 20,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 150,
    width: 25,
    height: 120,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 170,
    width: 20,
    height: 80,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385,
    y: 150,
    width: 25,
    height: 120,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365,
    y: 170,
    width: 20,
    height: 80,
    rx: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable4);
export default __webpack_public_path__ + "static/media/table4.1eac563555a01497f1ba8ebc4ce34c02.svg";
export { ForwardRef as ReactComponent };